/** ***********
*
* <beacon-layer.reducer.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { EsriBeacon } from './../../models/beacon';
import { errorFetchBeaconLayer, fetchBeaconLayer, resetBeaconLayer, successFetchBeaconLayer } from '../actions/beacon-layer.action';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
    data: EsriBeacon[];
    loading: boolean;
    loaded: boolean;
}

// default state
const INIT_STATE: State = {
    data: undefined,
    loading: false,
    loaded: false
};

const BeaconLayerReducer = createReducer(
    INIT_STATE,
    on(fetchBeaconLayer, (state): State => ({
        ...state, loading: true,
    })),
    on(successFetchBeaconLayer, (state, { beacons }): State => ({
        ...state,
        loading: false,
        loaded: true,
        data: beacons
    })),
    on(errorFetchBeaconLayer, (state): State => ({
        ...state, loading: false,
    })),
    on(resetBeaconLayer, (state): State => ({
        ...state,
        loading: false,
        loaded: false,
        data: undefined
    })),
);

export function reducer(state: State | undefined, action: Action) {
    return BeaconLayerReducer(state, action);
}
